import { CascadePicker, CascadePickerProps } from './CascadePicker'
import React, { useEffect, useState } from 'react'
import type { FC } from 'react'
import { PickerValue } from '@tinper/m';
import { renderToBody } from '@utils/RenderToBody';

export function prompt(
  props: Omit<CascadePickerProps, 'value' | 'visible' | 'children'>
) {
  return new Promise<PickerValue[] | null>(resolve => {
    const Wrapper: FC = () => {
      const [visible, setVisible] = useState(false)
      useEffect(() => {
        setVisible(true)
      }, [])
      return (
        <CascadePicker
          {...props}
          visible={visible}
          onConfirm={(val, extend) => {
            props.onConfirm?.(val, extend)
            resolve(val)
          }}
          onClose={() => {
            props.onClose?.()
            setVisible(false)
            resolve(null)
          }}
          afterClose={() => {
            props.afterClose?.()
            unmount()
          }}
        />
      )
    }
    const unmount = renderToBody(<Wrapper />)
  })
}
